import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=c0dd8278"
import script from "./ObjectInfo.vue?vue&type=script&lang=js"
export * from "./ObjectInfo.vue?vue&type=script&lang=js"
import style0 from "./ObjectInfo.vue?vue&type=style&index=0&id=c0dd8278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports